export default "/static/63e75c30d2c2690a.svg"